import { Action } from '../types/types';
import * as A from '../actions/font-assets';
import { handle } from 'redux-pack';
import { FontAsset, FontAssetUploadAlert, fontAssetUploadAlerts, FontUploadAlert } from '../types/font-assets';

export interface FontAssetsState {
	allFontAssets: FontAsset[];
	allFontsLoading: boolean;
	lastUploadedFont: FontAsset | null;
	uploadingFont: boolean;
	fontUploadAlert: FontAssetUploadAlert | null,
}

export const initialFontAssetsState: FontAssetsState = {
	allFontAssets: [],
	allFontsLoading: false,
	lastUploadedFont: null,
	uploadingFont: false,
	fontUploadAlert: null,
}

 const alphabetical = (a:FontAsset, b:FontAsset) => a.name.localeCompare(b.name);

const actions: Map<string, (
	statestore: FontAssetsState,
	action: Action
) => FontAssetsState> = new Map([

	[A.LOAD_FONT_ASSETS, (s: FontAssetsState, a: Action) => handle(s, a, {
		start: (state) => ({...state, allFontsLoading: true}),
		finish: (state) => ({...state, allFontsLoading: false}),
		failure: (state) => state,
		success: (state) => ({
			...state,
			allFontAssets: a?.payload ? a.payload.sort(alphabetical) : state.allFontAssets
		}),
	})],
	[A.SAVE_FONT_ASSET, (s: FontAssetsState, a: Action) => handle(s, a, {
		start: (state) => ({...state, uploadingFont: true}),
		finish: (state) => ({...state, uploadingFont: false}),
		failure: (state) => {
			return {
				...state,
				lastUploadedFont: null,
				fontUploadAlert: fontAssetUploadAlerts[FontUploadAlert.Generic]
			};
		},
		success: (state) => {
			if (!a?.payload?.name || typeof a.payload === 'string') {
				return {
					...state,
					lastUploadedFont: null,
					fontUploadAlert: fontAssetUploadAlerts[FontUploadAlert.DefaultExists]
				};
			}

			let didReplace = '';
			const nFontAssets = state.allFontAssets.reduce((acc: FontAsset[], curr) => {
				if (curr.name === a.payload.name) {
					didReplace = 'yes';
					acc.push(a.payload);
				} else {
					acc.push(curr);
				}
				return acc;
			}, [])
			
			if (didReplace === '') {
				nFontAssets.push(a.payload);
			}

			return {
				...state,
				lastUploadedFont: a?.payload,
				fontUploadAlert: didReplace 
					? fontAssetUploadAlerts[FontUploadAlert.ExistingOverriden]
					: state.fontUploadAlert,
				allFontAssets: nFontAssets.sort(alphabetical)
			};
		},
	})],
	[A.CLEAR_FONT_UPLOAD_ALERT, (s: FontAssetsState, a: Action) => {
		return {...s, fontUploadAlert: null};
	}]
]);

export function FontAssetsReducer(s: FontAssetsState = initialFontAssetsState, action: Action) {
	return actions.get(action.type)?.(s, action) || s;
}